<template>
  <div>
    <div>
      МедТочка — это удобное, совершенно бесплатное приложение для клиники. Удобство заключается в том, что пациент
      может записаться на повторный прием и оставить отзыв о враче, которого уже посетил. Таким образом, клиника
      получает обратную связь и повышение рейтинга, основанное на доверии пациентов. Пациенты очень довольны, что
      выписки врача всегда под рукой в электроном виде, не нужно с собой носить бумаги с заключениями. Кроме того,
      пациент может выбрать доктора через приложение и записаться на удобное время.
    </div>
  </div>
</template>
